export default "__VITE_ASSET__6634158a__"